module.exports = __webpack_public_path__ + "static/media/remote.62d6bbc8.png";